import SDAxios from '../../http/requests/timeline/index';

export default {
    /**
     * Retrieves Shop Drawing information.
     *
     * @param commit Vuex commit function
     * @param payload Payload data
     *
     * @returns {Promise<unknown>}
     */
    getTimelineData: function ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            let reset = false;
            if (this.state.timeline.firstPageUrl !== payload.firstPageUrl || (payload.resetTimelineItems !== undefined && payload.resetTimelineItems === true)) {
                commit('RESET_TIMELINE_ITEMS');
                reset = true;
            }

            if (this.state.timeline.firstPageUrl !== payload.nextPageUrl || reset) {
                commit('SET_LOADER_ENABLED', true);
                SDAxios.getTimelineData(payload.nextPageUrl, { onlyMine: this.state.timeline.onlyMine ? 1 : 0 })
                    .then((response) => {
                        if (!response.data.success) {
                            reject({ message: response.data.message });
                        }

                        commit('SET_TIMELINE_DATA', response.data.data);

                        resolve(response);
                    }).catch((error) => {
                    reject(error);
                }).finally(() => {
                    commit('SET_LOADER_ENABLED', false);
                });
            }
        });
    },

    /**
     * Sets is maximized flag.
     *
     * @param commit Vuex commit function
     * @param payload Payload data
     */
    setIsMaximized ({ commit }, payload) {
        commit('SET_IS_MAXIMIZED', payload);
    },
};
